import Link from 'components/shared/Link/Link';
import Image from 'next/image';
import { ArrowRight } from '@1debit/icons';

import * as m from 'motion/react-m';
import { AnimatePresence } from 'motion/react';
import { MENU_CLOSE_DURATION } from './animations';
import { cn } from 'utils/styles';
import { BackgroundColor } from 'types/constants';

import { NavContentLinkProps } from 'libs/contentful/props';
import ChimeKitIcon from '../shared/LinkWithIcon/ChimeKitIcon';
export interface NavCoreButtonProps {
  linkContent: NavContentLinkProps;
}

const HorizontalNavSubMenu = ({ linkContent }: NavCoreButtonProps) => {
  const subMenuItems = linkContent.subMenu?.sublinksCollection.items;

  return (
    <AnimatePresence>
      <m.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: MENU_CLOSE_DURATION }}
        style={{ overflow: 'hidden' }}
        className={cn(
          'absolute hidden md:block top-full left-0 w-full px-6 z-51 border-t border-pebble overflow-hidden',
          BackgroundColor.White,
        )}>
        <div className="px-6 py-12 h-full">
          <div className="flex justify-between gap-6">
            <div className="flex-3">
              <h2 className="font-sans text-heading-lg">
                {linkContent.subMenu?.titleOverride ?? linkContent.link.label}
              </h2>
              <p className="font-serif text-label-serif my-2">{linkContent.subMenu?.mainDescription}</p>
              <Link href={`/${linkContent.link.internalPage?.slug}`} className="font-sans text-label font-bold">
                {linkContent.subMenu?.linkLabel} <ArrowRight className="ml-2" />
              </Link>
            </div>
            <div className="flex-4 grid grid-cols-2 gap-6">
              {subMenuItems?.map((item, i) => {
                const showIcon = item.chimeKitIconName != null || item.icon?.url != null;

                return (
                  <div className="relative" key={i}>
                    <div className="absolute top-0 left-0 pr-4">
                      {showIcon &&
                        (item.chimeKitIconName ? (
                          <ChimeKitIcon iconName={item.chimeKitIconName!} />
                        ) : (
                          item.icon && (
                            <Image src={item.icon.url} alt={item.icon.title} height={24} width={24} priority />
                          )
                        ))}
                    </div>
                    <div className="pl-10">
                      <Link href={`/${item.link.internalPage?.slug}`} className="font-sans text-label font-bold">
                        {item.link.label}
                      </Link>
                      <p className="font-serif text-label-serif">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </m.div>
    </AnimatePresence>
  );
};

export default HorizontalNavSubMenu;
